// #region imports

// --- Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-respondents-widget-header',
  templateUrl: './respondents-widget-header.component.html',
  styleUrls: ['./respondents-widget-header.component.scss'],
})
export class RespondentsWidgetHeaderComponent {
  @Input() expanded: boolean = false;

  @Output() toggle = new EventEmitter<boolean>();

  toggleClick() {
    this.toggle.emit(!this.expanded);
  }
}
